import * as React from "react"
import {Box} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";

import RawMatcherTargetActionsZoom from "./Zoom";
import RawMatcherTargetActionsPagination from "./Pagination";


export default function RawMatcherTargetActions({ targetIndex, handleChangeIndex, isLoadingMapping }) {

	return <CardSeeker sx={{ width: 1}} contentProps={{ sx: { display: 'flex', justifyContent: 'space-between' } }}>
		<RawMatcherTargetActionsZoom />

		<RawMatcherTargetActionsPagination
			number={targetIndex}
			setNumber={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
		/>

		<Box />
	</CardSeeker>
}